import { useEffect, useState } from "react";
import { AxiosError } from "axios";
import { Typography } from "@mui/material";

import { login } from "../../app/auth";
import { X_REQUEST_ID } from "../../app/client";
import Error from "../common/Error";

function Login() {
  const [error, setError] = useState<string | undefined>(undefined);

  useEffect(() => {
    login().catch((e: AxiosError) =>
      setError(e.response?.headers[X_REQUEST_ID])
    );
  }, []);

  if (error) return <Error error={error} />;

  return (
    <Typography variant="h6">
      Please wait while you are being logged in...
    </Typography>
  );
}

export default Login;
